import React from "react";
import { Modal } from "react-bootstrap";
import ViewForm from "../../Components/ApplicantProcessing/ViewForm";

const ViewFormModal = (props) => {
    const { handleViewForm, viewFormShowHide,
        workflowTask, selectedForm, handleFormUpdate, allowEdit,formName="" } = props;
    return (
        <Modal show={viewFormShowHide} centered dialogClassName="custom-inline-dialog">
            <style>
                {`
                  .custom-inline-dialog {
                    max-width: 80vw !important;
                    width: 80vw !important;
                  }
                `}
            </style>
            <Modal.Header closeButton onHide={handleViewForm}>
                <Modal.Title>{formName}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="border">
                <div className="row" style={{ height: "500px", overflow: "auto" }}>
                    <div className="col-md-12">
                        <ViewForm
                            formShowHide={viewFormShowHide}
                            handleFormShowHide={handleViewForm}
                            workflowTask={workflowTask}
                            selectedForm={selectedForm}
                            handleFormUpdate={handleFormUpdate}
                            allowEdit={allowEdit}
                        ></ViewForm>
                    </div>
                </div>
            </Modal.Body>
            {/* <Modal.Footer>
                <button
                    className="btn btn-sm btn-outline-default"
                    onClick={handleViewForm}
                >
                    <i className="fa fa-times" aria-hidden="true"></i> Close
                </button>
            </Modal.Footer> */}
        </Modal>
    );

}

export default ViewFormModal;